import gql from 'graphql-tag'

const accorpaClienti = gql`
  mutation accorpaClienti($clienteIdPrincipale: Int!, $clienteIdDaAccorpare: Int!) {
    accorpaClienti(clienteIdPrincipale: $clienteIdPrincipale, clienteIdDaAccorpare: $clienteIdDaAccorpare) {
      id
      agenteId
      nome
      comune
      email
      email2
      telefono
      telefono2
      dataNascita
      tipoPnl
      famiglia
      percheCompra
      quandoInteressato
      quantoInteressato
      voto
      dataCreazione
      daRicontattare
      dataUltimoContatto
      dataUltimaRichiesta
      zone {
        nome
      }
      interessi {
        nome
      }
    }
  }
`

export default accorpaClienti


// WEBPACK FOOTER //
// ./src/graphql/mutations/accorpaClienti.js